export function buildState(stateObj: Record<string, string>) {
    return btoa(JSON.stringify(stateObj));
}

export function parseState(state: string): Record<string, string> {
    return JSON.parse(atob(state));
}

export function splitOnWhitespace(str: string): string[] {
    return str.split(/\s+/).filter(Boolean);
}

export function deduplicateOnWhitespace(str: string): string[] {
    if (!str) return [];
    return Array.from(new Set(str.trim().split(/\s+/)));
}

export function deduplicateStringArray(arr: string[]): string[] {
    return [...new Set(arr)];
}

function _formatToMonthYear(date: Date): string {

    // Month abbreviation
    const month = date.toLocaleDateString("en-US", { month: "short" });

    // Last two digits of the year
    const year = String(date.getFullYear()).slice(-2);

    return `${month} ${year}`;
}


export function formatToMonthYear(iso: string): string {
    const date = new Date(iso + "T00:00");
    return _formatToMonthYear(date);
}

export function subtractMonthsAndFormatToMonthYear(iso: string, months: number): string {
    const date = new Date(iso + "T00:00");

    // Subtract months
    const d = new Date(date);
    d.setMonth(d.getMonth() - months);

    return _formatToMonthYear(d);
}




